var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeelowtohigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fee_low_to_high",
    "data-name": "fee low to high",
    transform: "translate(-6189 -13737)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2367",
    "data-name": "Rectangle 2367",
    width: 20,
    height: 20,
    transform: "translate(6189 13737)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8309",
    "data-name": "Path 8309",
    d: "M160.739,18.253l-.323-.323a.457.457,0,0,0-.647,0L158.2,19.5V9.193a.457.457,0,0,0-.457-.457h-.457a.457.457,0,0,0-.457.457V19.5l-1.573-1.573a.457.457,0,0,0-.647,0l-.323.323a.457.457,0,0,0,0,.647l2.905,2.9a.457.457,0,0,0,.647,0l2.905-2.905a.457.457,0,0,0,0-.644Z",
    transform: "translate(6359.36 13761.936) rotate(180)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8309-2",
    "data-name": "Path 8309",
    d: "M6.587,3.683l-.323.323a.457.457,0,0,1-.647,0L4.048,2.436V12.743a.457.457,0,0,1-.457.457H3.134a.457.457,0,0,1-.457-.457V2.436L1.1,4.009a.457.457,0,0,1-.647,0L.134,3.686a.457.457,0,0,1,0-.647l2.9-2.9a.457.457,0,0,1,.647,0l2.9,2.9a.457.457,0,0,1,0,.644Z",
    transform: "translate(6198.722 13753.199) rotate(180)",
    fill: "#3f2566"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeelowtohigh);
export default __webpack_public_path__ + "static/media/fee low to high.31ac67b9d2c39dbd597f79f7b82e5152.svg";
export { ForwardRef as ReactComponent };